import { useNavigate } from 'react-router-dom';

export const useMetricBuilderNavigate = () => {
  const navigate = useNavigate();

  const navigateMetricBuilderIndex = (options = {}) => {
    navigate(`/metric-builder`, options);
  };

  const navigateMetricBuilderFlowPage = (metricId, options = {}) => {
    navigate(`/metric-builder/flow/${metricId}`, options);
  };

  const navigateFlowDetailPage = (flowId, options = {}) => {
    navigate(`/workflow/flow/${flowId}`, options);
  };

  const navigatePatternDetailPage = (patternId, options = {}) => {
    navigate(`/workflow/pattern/${patternId}`, options);
  };

  const navigateMetricBuilderPage = (metricId, options = {}) => {
    navigate(`/workflow/metric/${metricId}`, options);
  };

  return {
    navigateMetricBuilderIndex,
    navigateMetricBuilderFlowPage,
    navigateFlowDetailPage,
    navigateMetricBuilderPage,
    navigatePatternDetailPage,
  };
};
